module.exports = __webpack_public_path__ + "static/img/Brad_Crouch_mobile.317b687.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brad_Crouch_mobile.jpg
// module id = oGnm
// module chunks = 0